<template>
  <b-modal :id="'ModalLimparNcm'">
    <Header mini titulo="limpar NCMs selecionadas" icone="eraser" cor="azul" slot="modal-header" />
    <template>
      <div class="modal-corpo">Tem certeza que deseja limpar sua lista de NCMs selecionadas?</div>
    </template>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Cancelar"
        icone="times"
        :click="cancelar"
      />
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Limpar"
        icone="check"
        :click="handleClick"
        cor="azul"
      />
    </template>
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";

export default {
  name: "ModalLimparNcm",
  components: {
    BotaoPadrao,
    Header
  },
  props: {
    limparSelecionados: Function,
    id: Number
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },

  methods: {
    handleKey(event) {
      let modal = document.getElementById("ModalLimparNcm");
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          this.limparSelecionados();
          this.$root.$emit("bv::hide::modal", "ModalLimparNcm");
        }
      }
    },
    handleClick() {
      this.limparSelecionados();
      this.$root.$emit("bv::hide::modal", "ModalLimparNcm");
    },
    cancelar() {
      this.$root.$emit("bv::hide::modal", "ModalLimparNcm");
    }
  }
};
</script>

<style lang="scss">
.modal-cabecalho {
  display: flex;
  flex-direction: column;
  align-items: center !important;
  justify-content: center;
}
.modal-cabecalho-interno {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.modal-icone-limpar {
  font-size: 40px;
  margin: 5px 0;
  color: var(--azul2);
}
.modal-corpo {
  text-align: center;
}
.botao-modal {
  margin: 0 0 0 10px !important;
}
</style>
